import React, { FC, CSSProperties, ReactElement } from 'react';
import s from './CardItem.module.css';
import Tooltip from '../../../../shared/ui/tooltip/Tooltip';
import IconInformation from '../../../../shared/ui/icons/IconInformation';

interface Item {
    text: string | React.ReactNode;
    isActive: boolean;
    tag: string;
    color?: string;
    icon?: ReactElement;
    tooltip?: React.ReactNode;
}

interface CardItemProps {
    item: Item;
    onClick: (item: Item) => void;
    disabled?: boolean;
    style?: CSSProperties;
    activeStyle?: CSSProperties;
    showTooltipIcon?: boolean;
}

const CardItem: FC<CardItemProps> = ({
    item,
    onClick,
    disabled,
    style,
    activeStyle,
    showTooltipIcon = false,
}) => {
    const containerClass = `${s.container} 
        ${disabled && !item.isActive ? s.disabled : ''} 
        ${!activeStyle && item.isActive ? s.active : ''}`;

    const combinedStyle = {
        ...style,
        ...(item.isActive && activeStyle ? activeStyle : {}),
    };

    const cardContent = (
        <div className={containerClass} onClick={() => onClick(item)} style={combinedStyle}>
            {item.icon && item.icon}
            <span>{item.text}</span>
            {item.tooltip && item.icon && showTooltipIcon && (
                <div style={{ position: 'absolute', top: '5px', right: '8px', zIndex: 2 }}>
                    <Tooltip
                        content={item.tooltip}
                        position={'top'}
                        offsetX={50}
                        arrowOffsetX={-50}
                    >
                        <IconInformation width={15} height={15} />
                    </Tooltip>
                </div>
            )}
        </div>
    );

    if (item.tooltip && !item.icon) {
        return (
            <Tooltip content={item.tooltip} position={'top'}>
                {cardContent}
            </Tooltip>
        );
    }

    return cardContent;
};

export default CardItem;
